/**
 * **옵션을 소속 옵션그룹으로 묶는 규칙 한 곳** — 의존성이 없는 순수 모듈이다(Vue·Element·`@/` 별칭 금지).
 *
 * 메뉴 편집 다이얼로그의 옵션 선택기 두 개(`opt-combo`·`opt-select`)가 `GET /smenuOpt` 목록을 받아
 * 그룹별 `<el-option-group>` 으로 그린다. 그 묶는 루프가 **두 벌 복사돼 있었고**, 서버가 목록 행의
 * 모양을 바꾸는 순간 두 벌이 동시에 틀린다 — 그런데 증상은 오류가 아니라 **모든 옵션이 「(그룹 없음)」
 * 한 덩어리로 보이는 것**이라 화면만 봐서는 고장인 줄 모른다. 그래서 규칙을 여기 한 곳에 둔다.
 *
 * **그룹 축은 평면 필드다**(회차 3, 계획 §5.2). 목록 응답은 표시용 프로젝션이라 중첩 `smenuOptTp`
 * 객체를 싣지 않는다 — 692행짜리 목록에서 행마다 그룹 엔티티를 따라가던 것이 이 회차가 없앤 비용
 * 자체다. 세 칸은 `smenuOptTpCd`·`smenuOptTpNm`·`optTpNm` 이고, 마지막은 전환 전
 * `smenuOptTp.optTp.nmLan` 과 같은 값(「필수 선택 옵션」·「선택 사항 옵션」·「수량 설정 가능 옵션」)이며
 * 그룹이 없는 옵션에서는 `null` 이다. **있으면 라벨에 괄호로 붙이고 없으면 뺀다** — 서버가 그 칸을
 * 내리지 않는 판에서도 라벨이 「그룹 이름 ()」 꼴로 깨지지 않아야 한다.
 */

/** 그룹이 없는 옵션이 모이는 자리 — 키가 `null` 이면 객체 키로 못 쓰므로 한 낱말로 고정한다 */
export const NO_GROUP_KEY = '_'

/** 그룹 없는 묶음의 라벨 — 자식 템플릿이 빈 문자열을 그리면 라벨 없는 칸이 된다 */
export const NO_GROUP_LABEL = '(그룹 없음)'

/**
 * 한 옵션 행의 **그룹 라벨** — `사이드 선택 (선택 옵션)` 꼴.
 *
 * @param {object} row 옵션 행(`smenuOptTpNm`·`optTpNm`)
 * @returns {string} 라벨. 그룹 이름이 없으면 [NO_GROUP_LABEL]
 */
export function smenuOptGroupLabel(row) {
  const groupNm = (row && row.smenuOptTpNm) || ''
  const optTpNm = (row && row.optTpNm) || ''
  const label = groupNm + (optTpNm ? ' (' + optTpNm + ')' : '')

  return label || NO_GROUP_LABEL
}

/**
 * 옵션 목록을 **등장 순서대로** 그룹으로 묶는다 — 서버가 준 순서가 곧 사람이 보는 순서다.
 *
 * 정렬을 여기서 다시 하지 않는다: 목록의 순서는 이제 서버 `ORDER BY` 가 정하므로, 화면이 한 번 더
 * 늘어놓으면 두 곳이 순서를 말하게 된다.
 *
 * @param {Array} rows 옵션 행 목록(배열이 아니면 빈 결과)
 * @returns {Array<{tpCd: (number|string), label: string, items: Array}>}
 */
export function smenuOptGroupsOf(rows) {
  const list = Array.isArray(rows) ? rows : []
  const order = []
  const map = {}

  list.forEach(function (row) {
    const tpCd = row && row.smenuOptTpCd != null ? row.smenuOptTpCd : NO_GROUP_KEY

    if (!map[tpCd]) {
      map[tpCd] = { tpCd: tpCd, label: smenuOptGroupLabel(row), items: [] }
      order.push(tpCd)
    }

    map[tpCd].items.push(row)
  })

  return order.map(function (key) {
    return map[key]
  })
}
